//
// Timer class
//
// Used to create a timer that either calls back every frame, or calls back when complete
// To use, add the following:-
//
//   <script src="scripts/BPlib/BPtimer.js"></script>
//   BPtimer.addTimer(time, tickCallback, completeCallback);
//
//   Note all time is in milliseconds

timerManager = {};
timerManager.activeTimers = [];

timerManager.addTimeout = function(time, completeCallback, data) {
    // Timer fires a function when time expires
    return timerManager.addTimer(time, undefined, completeCallback, data);
};

timerManager.addTimer = function(time, tickCallback, completeCallback, data) {
    return timerManager.addDelayedTimer(0, time, tickCallback, completeCallback, data);
};

timerManager.addDelayedTimer = function(delay, time, tickCallback, completeCallback, data) {
    var newTimer = {};
    newTimer.delay = delay;
    newTimer.totalTime = time;
    newTimer.remainingTime = time;
    newTimer.tickCallback = tickCallback;
    newTimer.completeCallback = completeCallback;
    newTimer.data = data;

    timerManager.activeTimers.push(newTimer);

    return newTimer;
};

timerManager.stop = function(timer){
    var index = timerManager.activeTimers.indexOf(timer);
    if (index !== -1) {
        // Stop this timer. As we stopped, we dont call the callback if defined. It will be cleaned up by the main loop
        timer.remainingTime = 0;
        timer.completeCallback = undefined;
    }
};

timerManager.update = function(delta) {
    for (var i = timerManager.activeTimers.length - 1; i >= 0; i--) {
        var timer = timerManager.activeTimers[i];

        // update timer
        if (timer.delay > 0) {
            // Pre delay
            timer.delay -= delta;
        }
        else {
            // Main timer
            timer.remainingTime -= delta;
            if (timer.remainingTime <= 0) {
                // Complete
                timerManager.activeTimers.splice(i, 1);
                if (typeof(timer.completeCallback) !== "undefined") {
                    timer.completeCallback(timer.data);
                }
            }
            else {
                // Running
                if (typeof(timer.tickCallback) !== "undefined") {
                    timer.tickCallback(1 - timer.remainingTime / timer.totalTime, timer.data);
                }
            }
        }
    }
};

Reflex.addToUpdate(timerManager.update);